import {ReactComponent as RelojSVG} from "../icons/reloj.svg";


const IconUnidadEntrega = ({ unidad, height = 15 }) => {
  if (!unidad?.entrega) return null;

  return (
    <RelojSVG
      title="La unidad tiene entrega para hoy"
      style={{
        height: `${height}px`,
        width: `${height}px`,
        fill: "#ff4b4b",
        verticalAlign: "middle",
      }}
    />
  );
};


export default IconUnidadEntrega;
